import { User } from 'firebase';

export interface IUserType extends User {
  role?: string;
  brandIds?: number[];
  brandUserIds?: number[];
  id?: number;
}

type authUser = {
  displayName: string | null;
  email: string;
  photoURL: string | null;
  uid: string;
  phoneNumber: string | null;
  refreshToken: string;
  tenantId: string | null;
  emailVerified: boolean;
  isAnonymous: boolean;
  metadata: {
    creationTime: string;
    lastSignTime: string;
  };
};

export type pagePathAttributes = {
  params: { [key: string]: string };
};

export type pagePathContext = {
  search: string;
};

export type RoutePageProps = {
  user: authUser;
};

export enum UserRoles {
  SUPER_USER = 'SUPER_USER',
  GENERAL_USER = 'GENERAL_USER',
  ADMIN_USER = 'ADMIN_USER',
}

export default User;
